"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefinables = void 0;
const definables_1 = require("./definables");
const getDefinables = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- The args are not relevant to this function.
prototype) => {
    var _a;
    const retrievedDefinables = new Map();
    (_a = definables_1.definables
        .get(prototype.name)) === null || _a === void 0 ? void 0 : _a.forEach((definable, id) => {
        retrievedDefinables.set(id, definable);
    });
    return retrievedDefinables;
};
exports.getDefinables = getDefinables;
